import type { IconDefinition } from "@fortawesome/free-regular-svg-icons";
import { faCheck, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, type ButtonProps } from "components/Theme/button.tsx";
import type React from "react";

export interface CreateButtonProps
  extends Omit<ButtonProps, "outline" | "bright" | "plain"> {
  loading?: boolean;
  labelText?: string;
  labelIcon?: IconDefinition;
}

export default function CreateButton(
  props: CreateButtonProps,
): React.ReactElement {
  const {
    loading,
    labelText = "Create",
    labelIcon = faCheck,
    color = "green",
    disabled,
    ...rest
  } = props;
  return (
    <Button color={color} disabled={loading || disabled} {...rest}>
      <>
        <FontAwesomeIcon
          icon={loading ? faSpinner : labelIcon}
          fixedWidth
          spin={loading}
        />
        {labelText}
      </>
    </Button>
  );
}
